export default __webpack_public_path__ + "static/media/chatBot.4f6b751f.svg";